import React from 'react';
import styled from 'styled-components';
import {FormSection, formValueSelector, reduxForm} from 'redux-form'
import SubmitButtons from './sections/SubmitButtons';
import { scrollContentWrapperToTop } from '../../../../../utils/utils';
import formMessages from '../../../../../intl/admin/escalationSchemaMessages';
import {
    ESCALATION_SCHEMA_FORM, FORM_ESCALATION_SCHEMA_ESCALATION_SECTION,
    FORM_ESCALATION_SCHEMA_INFO_SECTION, FORM_FIELD_ES_SG_NAME,
} from '../../../../../constants/formConstants';
import RenderSyncErrors from '../../../../common/RenderSyncErrors'
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import EscalationInfoSection from './sections/info/EscalationInfoSection';
import {intlEscalationSchemaFieldMapping} from '../../../../../constants/escalationSchemaFieldLabelMapping';
import EscalationSection from './sections/escalation/EscalationSection';


const StyledDiv = styled.div`
  border-radius: 10px;
`;

const EscalationSchemaForm = (props) => {
    const { form, reqFields, readOnly, edit, handleSubmit, domain, selectedSG } = props;

    return (
        <StyledDiv className="border border-dark p-4 bg-light">
            <RenderSyncErrors form={form}
                              intlMessages={formMessages}
                              mapping={intlEscalationSchemaFieldMapping}/>
            <FormSection name={FORM_ESCALATION_SCHEMA_INFO_SECTION}>
                <EscalationInfoSection form={form}
                             domain={domain}
                             reqFields={reqFields}
                             readOnly={readOnly || edit}/>
            </FormSection>
            { selectedSG &&
                <FormSection name={FORM_ESCALATION_SCHEMA_ESCALATION_SECTION}>
                    <EscalationSection form={form}
                                 domain={domain}
                                 reqFields={reqFields}
                                 readOnly={readOnly}/>
                </FormSection>
            }
            <SubmitButtons form={form}
                           reqFields={reqFields}
                           readOnly={readOnly}
                           onSubmit={handleSubmit}
                           onSubmitFail={scrollContentWrapperToTop}/>
        </StyledDiv>
    )
};

const mapStateToProps = (state, props) => ({
    selectedSG: formValueSelector(props.form)(state, `${FORM_ESCALATION_SCHEMA_INFO_SECTION}.${FORM_FIELD_ES_SG_NAME}`),
});

const mapDispatchToProps = (dispatch, props) => ({

});

export default reduxForm({
    form: ESCALATION_SCHEMA_FORM,
})(injectIntl(connect(mapStateToProps, mapDispatchToProps)(EscalationSchemaForm)));

